export const previewUser = {
  email: "luiluir1010@gmail.com",
  first_name: "DO_NOT_DELETE",
  last_name: "_FORTEST",
  linkedin_id: "usoCXz7S73",
  picture_url:
    "https://media.licdn.com/dms/image/D5603AQHBXvS_Pjk8Yg/profile-displayphoto-shrink_100_100/0/1711208123938?e=1720051200&v=beta&t=k-YaOmj6SK2ltQo7kSOE-2wQitqoEEyRPgX27aS1w9s",
  resume: {
    text: "DO_NOT_DELETE_FORTEST",
    url: "Resume-HuyHoang.pdf",
  },
  __v: 0,
  _id: "663009c09004ced3b81eeaf1",
};
